import { useState, useEffect, useCallback } from "react";
import SEO from "../components/SEO";

const imageFiles = [
  "3350-Rectum.jpg",
  "3342-GI-Tract.jpg",
  "3300-Liver.jpg",
  "3310-Liver-With-Pathologies.jpg",
  "3330-Pancreas.jpg",
  "3110-Lung-Set-With-Pathologies.jpg",
  "3250-Kidney.jpg",
  "3260-Kidney-Cancer.jpg",
  "1000-Basic-Knee.jpg",
  "1010-Meniscus-Knee.jpg",
  "1060-Muscled-Knee.jpg",
  "1100-4-Stage-Osteoarthritic-Knee.jpg",
  "1260-Basic-Hip.jpg",
  "1310-Muscled-Hip.jpg",
  "1311-Muscled-Hip-With-Sciatic-Nerve.jpg",
  "1320-4-Stage-Degenerative-Bone-Diseases-of-the-Hip.jpg",
  "1500-Basic-Vertebrae.jpg",
  "1510-Sacrum-T8-Spine.jpg",
  "1650-4pc-Osteoporosis-Hinged-Disk-Set.jpg",
  "1700-5pc-Vertebrae-with-Sacrum.jpg",
  "1720-Deluxe-Muscled-Cervical.jpg",
  "1760-4-stage-Vertebrae.jpg",
  "1790-Basic-Shoulder.jpg",
  "1800-4-stage-OA-Shoulder.jpg",
  "1810-Muscled-Shoulder.jpg",
  "1830-Basic-Elbow.jpg",
  "1850-Muscled-Elbow.jpg",
  "1900-Mini-Muscled-Joint-Set.jpg",
  "1910-Mini-Implant-Joint-Set.jpg",
  "1920-Hand-Wrist.jpg",
  "1930-OA-Hand.jpg",
  "1931-Rheumatoid-Arthritis-Hand.jpg",
  "1980-FootAnkle-–-Plantar-Fasciitis.jpg",
  "1985-Gout.jpg",
  "2000-Stomach-With-Ulcers.jpg",
  "2001-Stomach-Cancer.jpg",
  "2010-GastroEsophageal-Reflux-Disease GERD.jpg",
  "2250-Ear.jpg",
  "2251-Full-Size-Normal-Clear-Ear.jpg",
  "2300-Child-Ear.jpg",
  "2500-Heart.jpg",
  "2550-3-pc-Heart-Set.jpg",
  "2575-Coronary-Arteries-and-Cardiac-Veins-No-Base.jpg",
  "2575-Coronary-Arteries-and-Cardiac-Veins.jpg",
  "2600-Artery.jpg",
  "2650-4-Piece-Artery-Open.jpg",
  "2650-4-Piece-Artery.jpg",
  "2655-4-Piece-Vein.jpg",
  "2750-Eye.jpg",
  "2751-Full-Eye.jpg",
  "2780-Cornea-Eye.jpg",
  "2800-Cataract-Eye.jpg",
  "2850-Sinus.jpg",
  "2851-Clear-Sinus.jpg",
  "2860-Teeth.jpg",
  "2861-Clear-Human-Jaw-with-Teeth.jpg",
  "2880-TMJ-Normal.jpg",
  "2880-TMJ-Pathology.jpg",
  "2880-TMJ.jpg",
  "2900-Brain.jpg",
  "2950-Half-Brain.jpg",
  "3000-Prostate.jpg",
  "3100-Lung.jpg",
  "3120-4-Pc-Bronchus-Detail-1.jpg",
  "3120-4-Pc-Bronchus-Detail-2.jpg",
  "3120-4-Pc-Bronchus-Detail-3.jpg",
  "3120-4-Pc-Bronchus-Detail-4.jpg",
  "3120-4-Pc-Bronchus-Open.jpg",
  "3120-4-Pc-Bronchus.jpg",
  "3130-COPD.jpg",
  "3150-Thyroid-Detail-1.jpg",
  "3150-Thyroid-Detail-2.jpg",
  "3150-Thyroid-Detail-3.jpg",
  "3150-Thyroid-Detail-4.jpg",
  "3150-Thyroid.jpg",
  "3340-Colon.jpg",
  "3341-4-pc-Colon.jpg",
  "3401-Breast-With-Irregular-Masses.jpg",
  "3450-Breast-Cross-Section.jpg",
  "3480-Uterus-Ovary.jpg",
  "3500-Female-Pelvis.jpg",
  "3550-Male-Pelvis-With-Prostate.jpg",
  "3551-Male-Pelvis-With-Framed-Prostates.jpg",
  "3552-Male-pelvis-BPH.jpg",
  "3570-Male-Pelvis-with-Testicles.jpg",
  "3600-Obesity.jpg",
  "3750-Skin-Acne.jpg",
  "3751-Skin-Normal-Acne.jpg",
  "3800-Skin-Normal-Burn.jpg",
  "3851-Precancerous-and-Cancerous-Skin-Lesions-AK.jpg",
  "3851-Precancerous-and-Cancerous-Skin-Lesions-BC.jpg",
  "3851-Precancerous-and-Cancerous-Skin-Lesions-DN.jpg",
  "3851-Precancerous-and-Cancerous-Skin-Lesions-MM.jpg",
  "3851-Precancerous-and-Cancerous-Skin-Lesions-SC.jpg",
  "3851-Precancerous-and-Cancerous-Skin-Lesions.jpg",
  "3855-Skin-Cancer.jpg",
  "3900-Aging-Skin-Hair-Loss.jpg",
  "4000-Hypertension.jpg",
  "4010-Diabetes.jpg",
  "4011-4-pc-Diabetes.jpg",
  "4020-Metabolic_Syndrome.jpg",
  "9050-Canine-Knee.jpg",
  "9051-4-stage-Canine-Knee-Set.jpg",
  "9060-Canine-Pelvis.jpg",
  "9070-Canine-Elbow.jpg",
  "9075-Canine-Shoulder.jpg",
  "9080-Canine-Vertebral-Column.jpg",
  "9090-Canine-Skin-With-Flea.jpg",
  "9095-Parasites.jpg",
  "9141-Feline-Heart-Lung.jpg",
  "9151-Canine-Heart-Lung.jpg",
  "9160-Feline-Pelvis.jpg",
  "9170-Feline-Shoulder.jpg",
  "9190-Feline-Jaw.jpg",
  "9191-Clear-Feline-Jaw.jpg",
  "9195-Canine-Jaw.jpg",
  "9196-Clear-Canine-Jaw.jpg",
  "9200-Canine-Ear.jpg",
  "9210-2-Piece-Companion-Animal-Kidney.jpg",
];

function toEncodedSrc(filename: string): string {
  return `/images/Anatomical%20Models/${filename.replace(/ /g, "%20")}`;
}

function getProductName(filename: string): string {
  // Remove extension
  const noExt = filename.replace(/\.(jpg|jpeg|png|gif|webp)$/i, "");
  // Remove leading number code (e.g. "1000-", "3120-")
  const noCode = noExt.replace(/^\d+-/, "");
  // Replace hyphens and underscores with spaces
  return noCode.replace(/[-_]/g, " ");
}

interface ModelItem {
  filename: string;
  name: string;
  src: string;
}

const models: ModelItem[] = imageFiles.map((filename) => ({
  filename,
  name: getProductName(filename),
  src: toEncodedSrc(filename),
}));

export default function AnatomicalModels() {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const close = useCallback(() => setSelectedIndex(null), []);

  const prev = useCallback(() => {
    setSelectedIndex((i) => (i !== null ? (i - 1 + models.length) % models.length : 0));
  }, []);

  const next = useCallback(() => {
    setSelectedIndex((i) => (i !== null ? (i + 1) % models.length : 0));
  }, []);

  useEffect(() => {
    if (selectedIndex === null) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
      else if (e.key === "Escape") close();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [selectedIndex, prev, next, close]);

  useEffect(() => {
    if (selectedIndex !== null) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [selectedIndex]);

  const selected = selectedIndex !== null ? models[selectedIndex] : null;

  return (
    <>
      <SEO
        title="Anatomical Models | Haptone"
        description="Browse our complete collection of high-quality anatomical models for medical, veterinary, and educational training."
      />

      <div className="min-h-screen bg-gray-50 pb-16">
        {/* Hero */}
        <section className="relative pt-32 pb-16 overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(/antm.jpg)` }} />
          <div className="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/80 to-primary/50" />
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl sm:text-5xl font-bold text-white leading-tight">
              Anatomical Models
            </h1>
            <p className="mt-4 text-white/80 text-lg max-w-2xl leading-relaxed">
              High-fidelity anatomical models for medical education, surgical training, and veterinary practice.
            </p>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10">

          {/* Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {models.map((model, index) => (
              <button
                key={model.filename}
                onClick={() => setSelectedIndex(index)}
                className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 hover:border-accent/30 text-left focus:outline-none focus:ring-2 focus:ring-accent"
              >
                <div className="aspect-square overflow-hidden bg-white flex items-center justify-center p-2">
                  <img
                    src={model.src}
                    alt={model.name}
                    className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                <div className="p-2.5">
                  <p className="text-xs font-medium text-primary leading-snug line-clamp-2">
                    {model.name}
                  </p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {selected && selectedIndex !== null && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm"
          onClick={close}
        >
          {/* Content */}
          <div
            className="relative max-w-3xl w-full mx-4 bg-white rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close */}
            <button
              onClick={close}
              className="absolute top-3 right-3 z-10 bg-white/90 hover:bg-white rounded-full w-9 h-9 flex items-center justify-center text-gray-600 hover:text-primary shadow transition-colors"
              aria-label="Close"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>

            {/* Image */}
            <div className="bg-gray-50 flex items-center justify-center" style={{ maxHeight: "70vh" }}>
              <img
                src={selected.src}
                alt={selected.name}
                className="max-h-[70vh] w-full object-contain"
              />
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between px-5 py-4">
              <button
                onClick={prev}
                className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-primary transition-colors"
                aria-label="Previous"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
                Prev
              </button>

              <div className="text-center px-4">
                <p className="text-sm font-semibold text-primary">{selected.name}</p>
                <p className="text-xs text-gray-400 mt-0.5">{selectedIndex + 1} / {models.length}</p>
              </div>

              <button
                onClick={next}
                className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-primary transition-colors"
                aria-label="Next"
              >
                Next
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            </div>
          </div>

          {/* Side nav arrows */}
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white rounded-full w-11 h-11 flex items-center justify-center transition-colors"
            aria-label="Previous"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white rounded-full w-11 h-11 flex items-center justify-center transition-colors"
            aria-label="Next"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        </div>
      )}
    </>
  );
}
